import {userPool} from "../../userpool";

export function logout(){
  const user = userPool.getCurrentUser();
  user?.signOut();
  window.location.replace("/")
}